export const getElementCoordinate = (elem) => {
    let x = 0;
    let y = 0;
    while (elem.offsetParent) {
        x += elem.offsetLeft;
        y += elem.offsetTop;
        elem = elem.offsetParent;
    }
    return { x, y };
}

export default {
    getElementCoordinate
}

  


// WEBPACK FOOTER //
// ./public/scroll-bar/uitls/helper.js